
// Debounce helper: delays fn execution until ms after last call
function debounce(fn, ms) {
  var timer;
  return function() {
    clearTimeout(timer);
    timer = setTimeout(fn, ms);
  };
}

// Guard: only init slick if the element exists on this page
if ($('.review_slider').length) {
  $('.review_slider').slick({
    infinite: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1
  });
}

jQuery(".footer-block__heading").click(function() {
  if ($(window).width() <= '749') {
    if (jQuery(this).hasClass("show")) {
      jQuery(this).removeClass("show");
      jQuery(this).next().slideUp();
    } else {
      jQuery(".footer-block__heading").removeClass("show");
      jQuery(".footer-block__heading").next().slideUp();
      jQuery(this).addClass("show");
      jQuery(this).next().slideDown();
    }
  }
});

$(document).ready(function() {
  // Guard: only init magnificPopup if elements exist on this page
  if ($('.popup-youtube, .popup-vimeo, .popup-gmaps').length) {
    $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
      disableOn: 700,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });
  }

  if ($('.image-popup-vertical-fit').length) {
    $('.image-popup-vertical-fit').magnificPopup({
      type: 'image',
      closeOnContentClick: true,
      mainClass: 'mfp-img-mobile',
      image: { verticalFit: true }
    });
  }
});

// Cookie helpers
function setCookie(name, value, minutes) {
  var expires = "";
  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
  }
  return null;
}

// Store collection URL in cookie
if (window.location.pathname.includes('/collections/')) {
  setCookie('lastCollection', window.location.href, 30);
}

// Update continue button URL — use MutationObserver instead of setInterval
// so we stop watching as soon as the button appears, not forever
function updateContinueButtonUrls() {
  var lastCollection = getCookie('lastCollection');
  if (!lastCollection) return;
  var continueBtns = document.querySelectorAll('.continue-btn');
  continueBtns.forEach(function(btn) {
    btn.setAttribute("href", lastCollection);
  });
  return continueBtns.length > 0;
}

// Run once immediately in case buttons already exist
if (!updateContinueButtonUrls()) {
  // Watch for .continue-btn to be added to the DOM, then stop observing
  var continueObserver = new MutationObserver(function() {
    if (updateContinueButtonUrls()) {
      continueObserver.disconnect();
    }
  });
  continueObserver.observe(document.body, { childList: true, subtree: true });
}
